export interface IRemoteDonorRegistration {
    registrationsRemotePatient: IRegistrationsForRemotePatient;
    statusAtOtherCenters: IRegistrationStatusAtOtherCenter;
    inProgressCandidates: IDonorRegistration[];
    inProgressCandidatesAll: IDonorRegistration[];
    donatedCandidates: IDonorRegistration[];
    donatedCandidatesAll: IDonorRegistration[];
    ruledOutCandidates: IDonorRegistration[];
    ruledOutCandidatesAll: IDonorRegistration[];
}

export interface IRegistrationsForRemotePatient {
    pendingReferral?: number;
    atYourCenter?: number;
    otherCenters?: number;
}

export interface IRegistrationStatusAtOtherCenter {
    inProgress?: number;
    inProgressAll?: number;
    ruledOut?: number;
    ruledOutAll?: number;
    donated?: number;
    donatedAll?: number;
}

export interface IDonorRegistration {
    centerAlias: string;
    donorName: string;
    referralDate: string;
    coordinatorName: string;
    coordinatorNumber: string;
    coordinatorEmail: string;
    lastUpdatedDate: string;
    currentStatusId: number,
    currentStatus: string;
    visibilityComments: string;
    statusActivityHistory: IDonorStatusLogContract[]
}


export interface IDonorStatusLogContract {
    regId: string;
    UpdatedByAlias: string;
    UserFName: string;
    UserLName: string;
    UpdatedDate: string;
    UpdatedStatus: string;
}
